/** Tiny className joiner — filters falsy values. Avoids pulling in a
 * dependency for the slice. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
